export const formatBytes = (bytes?: number): string | undefined => {
  if (!bytes) {
    return undefined;
  }

  const k = 1000;
  const sizes = ['B', 'KB', 'MB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};
